import { JSXElement, mergeProps, Show } from 'solid-js';
import { usePortalCustomizationContext } from '~/portal-customization/PortalCustomizations.tsx';
import { getLocalizedString } from '~/i18n/utils.ts';
import { getTranslationKey } from '~/pages/ExternalPages/commons/utils.tsx';
import { getLogoContainerClass } from '~/pages/Customizations/utils.ts';
import { LogoPositionOptions } from '~/api/types/customisationData.ts';
import { twMerge } from 'tailwind-merge';

type LogoProps = {
  logoPosition?: LogoPositionOptions;
  class?: string;
};

export default function Logo(props: LogoProps): JSXElement {
  const merged = mergeProps(
    {
      logoPosition: LogoPositionOptions.INSIDE_BOX,
      class: ''
    },
    props
  );
  const portalCustomization = usePortalCustomizationContext();

  return (
    <Show
      when={
        portalCustomization.brandConfig?.logoPosition === merged.logoPosition &&
        portalCustomization.brandConfig?.logoUrl
      }
    >
      <div
        class={twMerge(
          `mb-6`,
          getLogoContainerClass(portalCustomization.brandConfig ?? {}),
          merged.class
        )}
      >
        <img
          alt={
            portalCustomization.appConfig?.name
              ? getLocalizedString(
                  getTranslationKey(`alt_text_logo_with_app_name`),
                  {
                    appName: portalCustomization.appConfig?.name
                  }
                )
              : getLocalizedString(
                  getTranslationKey(`alt_text_logo_without_app_name`)
                )
          }
          src={portalCustomization.brandConfig?.logoUrl}
          class={`max-h-12 max-w-full`}
        />
      </div>
    </Show>
  );
}
